import React, { useContext } from 'react';
import Icon from '@mdi/react';
import { mdiChevronRight, mdiChevronLeft } from '@mdi/js';
import { CalendarContext } from '../../../../../pages/Activity/context/CalendarProvider';

import './DateSelect.scss';

export default function DateSelect() {
  const { goToNext, goToPrev, showDateBasedOnView } =
    useContext(CalendarContext);

  return (
    <div className="date-select d-flex align-items-center gap-3">
      <span className="chevron" onClick={goToPrev}>
        <Icon path={mdiChevronLeft} size={1.2} />
      </span>
      <span className="date-label">{showDateBasedOnView()}</span>
      <span className="chevron" onClick={goToNext}>
        <Icon path={mdiChevronRight} size={1.2} />
      </span>
    </div>
  );
}
